// API endpoints metier-aware.
//
// On expose `apiUtils.client`, `apiUtils.integration`, `apiUtils.integrationEnroll`,
// `apiUtils.integrationModel`, `apiUtils.notion` comme avant, mais résolus
// dynamiquement via des getters. Le métier courant doit être positionné via
// `setMetier(metier)` au tout début du chargement de la page (Enroll.vue),
// avant le moindre appel HTTP.

const BASES = {
  poissonnerie: 'https://api.hublot.io',
  boucherie:    'https://api.carnot.hublot.io',
}

const CLIENT_BASES = {
  poissonnerie: 'https://api.hublot.io',
  boucherie:    'https://api.carnot.hublot.io',
}

const DEFAULT_METIER = 'poissonnerie'

let currentMetier = DEFAULT_METIER

export const setMetier = (metier) => {
  currentMetier = BASES[metier] ? metier : DEFAULT_METIER
}

export const getMetier = () => currentMetier

const base = () => BASES[currentMetier] || BASES[DEFAULT_METIER]
const clientBase = () => CLIENT_BASES[currentMetier] || CLIENT_BASES[DEFAULT_METIER]

export const apiUtils = {
  get client            () { return `${clientBase()}/client/enroll` },
  get integration       () { return `${base()}/integration` },
  get integrationEnroll () { return `${base()}/integration/enroll` },
  get integrationModel  () { return `${base()}/integration/model` },
  get notion            () { return `${clientBase()}/notion` },
}

// Formulaire GLN : le magasin peut exister dans les deux univers, l'URL est donc
// construite pour un métier donné et non pour le métier courant.
export const glnUrl = (metier, idNotion) => `${CLIENT_BASES[metier]}/client/gln/${idNotion}`
